.group {
  display: flex;
  flex-direction: column;
  gap: var(--nexus-space-sm);
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  margin-bottom: var(--nexus-space-xs);
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-base);
  font-weight: var(--nexus-weight-semibold);
  color: var(--nexus-text);
}

.description,
.empty {
  margin: 0;
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-sm);
  color: var(--nexus-text-muted);
}

.people {
  display: flex;
  flex-direction: column;
  gap: var(--nexus-space-xs);
  margin: 0;
  padding: 0;
  list-style: none;
}

.person,
.personSelected {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--nexus-space-sm);
  padding: var(--nexus-space-sm) var(--nexus-space-md);
  border: 1px solid var(--nexus-border);
  border-radius: var(--nexus-radius-control);
  background: var(--nexus-surface);
}

.personSelected {
  border-color: var(--nexus-border-focus);
}

.who {
  display: flex;
  align-items: center;
  gap: var(--nexus-space-sm);
  min-width: 0;
}

.name {
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-sm);
  font-weight: var(--nexus-weight-medium);
  color: var(--nexus-text);
}

.none {
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-xs);
  font-style: italic;
  color: var(--nexus-text-muted);
}

.methods {
  display: flex;
  flex-wrap: wrap;
  gap: var(--nexus-space-xs);
}

.method,
.methodActive {
  display: inline-flex;
  align-items: center;
  gap: var(--nexus-space-xs);
  min-height: var(--nexus-control-sm);
  padding: 0 var(--nexus-space-sm);
  border: 1px solid var(--nexus-border);
  border-radius: var(--nexus-radius-sm);
  background: transparent;
  color: var(--nexus-text-muted);
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-sm);
  cursor: pointer;
  transition: background var(--nexus-transition-fast), color var(--nexus-transition-fast);
}

.method:hover {
  color: var(--nexus-text);
}

.methodActive {
  border-color: var(--nexus-border-focus);
  background: var(--nexus-primary);
  color: var(--nexus-text-on-primary);
  font-weight: var(--nexus-weight-semibold);
}

/* A radio dot: an empty ring when off, a filled one when chosen. */
.dot,
.dotOn {
  flex: none;
  box-sizing: border-box;
  width: 12px;
  height: 12px;
  border: 1.5px solid currentColor;
  border-radius: var(--nexus-radius-full);
}

.dotOn {
  background: radial-gradient(circle, currentColor 0 40%, transparent 45%);
}

.method:focus-visible,
.methodActive:focus-visible {
  outline: 2px solid var(--nexus-border-focus);
  outline-offset: 1px;
}

.icon {
  display: inline-flex;
}

.error {
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-xs);
  color: var(--nexus-danger);
}

.group:disabled .methods {
  opacity: 0.5;
}

@media (max-width: 768px) {
  .method,
  .methodActive {
    min-height: var(--nexus-control-md);
  }
}
